module.exports = __webpack_public_path__ + "static/media/gomphocerippus_rufus.8fd63ffd.jpg";